import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-car-icon lucide-car",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7,
			cy: 17,
			r: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "M9 17h6" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17,
			cy: 17,
			r: 2
		})
	]
});
export default SvgCar;
